module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-26.b8f9ecf7.svg";